import { Navigate, Outlet } from "react-router";
import { usePlatformAuth } from "../context/platform-auth";

export function RequirePlatformAuth() {
	const { user, loading } = usePlatformAuth();

	if (loading) return null;
	if (!user) return <Navigate to="/sign-in" replace />;
	return <Outlet />;
}
